import { render, staticRenderFns } from "./Form15CaseInformation.vue?vue&type=template&id=66e3ddc9&scoped=true"
import script from "./Form15CaseInformation.vue?vue&type=script&lang=ts"
export * from "./Form15CaseInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e3ddc9",
  null
  
)

export default component.exports